export default __webpack_public_path__ + "static/media/well2.9344f42c.png";